import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/ShadersWGSL/lensFlare.vertex.js
var name, shader, lensFlareVertexShaderWGSL;
var init_lensFlare_vertex = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/lensFlare.vertex.js"() {
    init_shaderStore();
    name = "lensFlareVertexShader";
    shader = `attribute position: vec2f;uniform viewportMatrix: mat4x4f;varying vUV: vec2f;const madd: vec2f= vec2f(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
@vertex
fn main(input : VertexInputs)->FragmentInputs {
#define CUSTOM_VERTEX_MAIN_BEGIN
vertexOutputs.vUV=input.position*madd+madd;vertexOutputs.position=uniforms.viewportMatrix* vec4f(input.position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
    ShaderStore.ShadersStoreWGSL[name] = shader;
    lensFlareVertexShaderWGSL = { name, shader };
  }
});

export {
  lensFlareVertexShaderWGSL,
  init_lensFlare_vertex
};
